export default __webpack_public_path__ + "static/Retail_D365-523d039c71964ad06cb863b2e963cb62.webp";